
import React, {useEffect, useState} from 'react';

import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import toast from "../../components/Toast/Toast";
import {postData} from "../../utils/TransactionUtil";


const REG200F2 = ({handle_Close, comHandleClick_Save, tarSelectObj}) => {

    // useEffect(() => {
    //
    // }, []);



    /* Event ==================================================================================================== */


    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            setUpdateDisableData();

        });
    }, [comHandleClick_Save]);


    /* Call Service====================================================================================================*/

    async function setUpdateDisableData() {
        if (window.confirm("정말 삭제하시겠습니까?")) {
            //사용자 등록
            const result = await postData("/RED/setUpdateDisableData", tarSelectObj);
            if(result===1) {
                toast({type: 'info', message: '데이터 삭제가 완료되었습니다.'});
            }
            handle_Close(result);
        }

    }


    return(
        <main>
            <div className={styleCom.main_wrap} style={{marginBottom: "10px"}}>
                <Table variant='default' rowCnt={6} colSize={['30%', '70%']} rowSize={'56px'}>
                    <div>기관명</div>
                        <div>{tarSelectObj.hsptNm}</div>
                    <div>Study ID</div>
                        <div>{tarSelectObj.studyId}</div>
                    <div>Enroll Date</div>
                        <div>{tarSelectObj.enrollDt}</div>
                    <div>이니셜</div>
                        <div>{tarSelectObj.initial}</div>
                    <div>연령</div>
                        <div>{tarSelectObj.age}</div>
                    <div>성별</div>
                        <div>{tarSelectObj.sexNm}</div>
                </Table>
            </div>

            <div className={styleCom.title_wrap}>
                <h3>대상자의 정보를 확인 후 '삭제' 버튼을 클릭하여 주십시오.</h3>
                <h4>(삭제시 해당 스터디 ID는 사용할 수 없습니다)</h4>
            </div>
        </main>
    )
}
export default REG200F2;